import { jsx as _jsx } from "react/jsx-runtime";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import List from "components/Lists/List";
const { forum: { GET_CATEGORIES } } = queries;
const { forum: { DELETE_CATEGORY } } = mutations;
const CategoriesList = () => (_jsx(List, { deleteMutation: DELETE_CATEGORY, itemNamePlural: "categories", label: "Categories", listQuery: GET_CATEGORIES, listQueryDataName: "categories", pathPrefix: "/forum" }));
export default CategoriesList;
